import React from 'react';
import cx from 'classnames';
import isObject from '../../support/shared/isObject';

type Props<T> = {
  options: Array<T>;
  selectedItem: T | null | undefined;
  onChange: (item: T) => void;
  getLabel?: (item: T) => string;
  block?: boolean;
};

export default function Dropdown<T>(props: Props<T>) {
  const { options, selectedItem, onChange, block, ...otherProps } = props;
  const getLabel = props.getLabel ?? getLabelFallback;

  const onChangeHandler = (event: { target: { value: string } }) => {
    const selectedIndex = Number(event.target.value);
    const selectedValue = options[selectedIndex];
    if (selectedValue) {
      onChange(selectedValue);
    }
  };

  const className = cx({
    dropdown: true,
    block: block,
  });
  let selectedIndex = 0;
  const optionElements = options.map((item, i) => {
    if (item === selectedItem) {
      selectedIndex = i;
    }
    return (
      <option key={i} value={i}>
        {getLabel(item)}
      </option>
    );
  });
  return (
    <span className={className}>
      <select {...otherProps} value={selectedIndex} onChange={onChangeHandler}>
        {optionElements}
      </select>
      <span>{selectedItem ? getLabel(selectedItem) : ''}</span>
    </span>
  );
}

function getLabelFallback(item: unknown) {
  if (isObject(item)) {
    return typeof item.name === 'string' ? item.name : '';
  }
  return item == null ? '' : String(item);
}
